import { jeepRallyApi } from "../api";

const baseUrl = "/api/v1/categories";

export const getAllCategories = () => {
  return jeepRallyApi.get(baseUrl);
};

export const createCategory = (formData) => {
  return jeepRallyApi.post(baseUrl, formData, {
    headers: {
      "Content-Type": undefined,
    },
  });
};

export const updateCategory = (id, formData) => {
  return jeepRallyApi.patch(`${baseUrl}/${id}`, formData, {
    headers: {
      "Content-Type": undefined,
    },
  });
};

export const deleteCategory = (id) => {
  return jeepRallyApi.delete(`${baseUrl}/${id}`);
};
